import { render, staticRenderFns } from "./h5.vue?vue&type=template&id=5e47f46a&scoped=true"
import script from "./h5.vue?vue&type=script&lang=js"
export * from "./h5.vue?vue&type=script&lang=js"
import style0 from "./h5.vue?vue&type=style&index=0&id=5e47f46a&prod&lang=css"
import style1 from "./h5.vue?vue&type=style&index=1&id=5e47f46a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e47f46a",
  null
  
)

export default component.exports